import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import SidebarMenu from "../../../Components/SidebarMenu";
import api from "../../../Services/api";
import { Page } from "../../SignedOut/Cadastro/styles";
import ReactLoading from "react-loading";
import {
	PacientInfo,
	InfoBlock,
	InfoTitle,
	Info,
	Content,
	PageTitle,
	Title,
} from "./styles";
import StatusDisplay from "../../../Components/Status";
import MainButton from "../../../Components/MainButton";
import { toast } from "react-toastify";
import PageContainer from "../../../Components/PageContainer";

export default function Pagar(props) {
	const { id } = useParams();
	const [loadingCreditos, setLoadingCreditos] = useState(true);
	const [VL_credito, setCreditos] = useState();
	const [loadingMargem, setLoadingMargem] = useState(true);
	const [porcent_margem, setMargem] = useState();
	const [loadingAlterar, setLoadingAlterar] = useState(false);
	const { consulta } = props.location.state;

	console.log("consulta", consulta);

	const fetchCreditos = async () => {
		setLoadingCreditos(true);
		try {
			const response = await api.get(`/admin/creditos`);
			setCreditos(response.data);
		} catch (error) {
			console.log(error);
		}
		setLoadingCreditos(false);
	};

	const fetchMargem = async () => {
		setLoadingMargem(true);
		try {
			const response = await api.get(`/admin/valor-margem`);
			setMargem(response.data);
		} catch (error) {
			console.log(error);
		}
		setLoadingMargem(false);
	};

	useEffect(() => {
		fetchCreditos();
		fetchMargem();
	}, []);

	const handleStatusChange = async () => {
		setLoadingAlterar(true);

		try {
			await api.patch(`/transferencia/alterar_status_admin/${id}`, { ST_transferencia_admin: "SUCESSO" });
			toast.success("Pagamento marcado como feito!");
			// Redireciona de volta para a lista de pagamentos
			window.history.back();
		} catch (error) {
			console.log(error);
			toast.error("Erro ao alterar status");
		} finally {
			setLoadingAlterar(false);
		}
	};

	if (loadingCreditos || loadingMargem) { //Loading da pagina
		return (
			<Page>
				<SidebarMenu />
				<PageContainer>
					<PageTitle>Pagar</PageTitle>
					<ReactLoading
						type="spin"
						color="#B2EBF2"
						height={"30px"}
						width={"30px"}
					/>
				</PageContainer>
			</Page>
		);
	}

	return (
		<Page>
			<SidebarMenu />
			<PageContainer>
				<PageTitle>Pagar</PageTitle>
				<Content>

					<PacientInfo> {/* Informações do Prestador */}
						<Title> Chave Pix do Prestador </Title>
						<InfoBlock>
							<InfoTitle>Tipo da chave:</InfoTitle>
							<Info>{consulta.medico.usuario.dados_pix.TP_chave_pix}</Info>
						</InfoBlock>
						<InfoBlock>
							<InfoTitle>Chave:</InfoTitle>
							<Info>{consulta.medico.usuario.dados_pix.CD_chave_pix}</Info>
						</InfoBlock>
					</PacientInfo>

					<PacientInfo> {/* Informações do Pagamento */}

						<Title> Pagamento </Title>

						<InfoBlock> {/*Realização da consulta*/}
							<InfoTitle>Realização do Atendimento</InfoTitle>

							<StatusDisplay status={consulta?.ST_transferencia}>
								{consulta?.ST_transferencia}
							</StatusDisplay>
						</InfoBlock>

						<InfoBlock> {/*Pagamento do Administrador*/}
							<InfoTitle>Pagamento do Administrador</InfoTitle>

							<StatusDisplay status={consulta?.ST_transferencia_admin}>
								{consulta?.ST_transferencia_admin}
							</StatusDisplay>
						</InfoBlock>

					</PacientInfo>

				</Content>

				<Title>Valores</Title>
				<Content>
					<PacientInfo> {/* Valor do Atendimento */}

						<InfoBlock> { /*Valor do atendimento em crédito*/}
							<InfoTitle>Valor do Atendimento:</InfoTitle>
							<Info>{consulta?.QT_credito} crédito(s)</Info>
						</InfoBlock>

						<InfoBlock> {/*Valor do atendimento em reais*/}
							<InfoTitle>Valor em Reais:</InfoTitle>
							<Info>R$ {consulta?.QT_credito * VL_credito} </Info>
						</InfoBlock>

					</PacientInfo>

					<PacientInfo> {/* valor a ser pago com margem padrão */}

						<InfoBlock> { /*Margem padrão do sistema*/}
							<InfoTitle>Margem Padrão do Sistema</InfoTitle>
							<Info>{porcent_margem * 100}%</Info>
						</InfoBlock>

						<InfoBlock> {/*Pagamento com margem padrão*/}
							<InfoTitle>Pagemento com Margem Padrão</InfoTitle>
							<Info>R$ {(consulta?.QT_credito * VL_credito * porcent_margem).toFixed(2)} </Info>
						</InfoBlock>

					</PacientInfo>

					<PacientInfo> {/* valor a ser pago com margem individual */}

						<InfoBlock>
							<InfoTitle>Margem Individual</InfoTitle>
							{consulta.medico.VL_margem_individual && <Info>{consulta.medico.VL_margem_individual * 100}%</Info>}
							{!consulta.medico.VL_margem_individual && <Info>Não se aplica</Info>}
						</InfoBlock>

						<InfoBlock>
							<InfoTitle>Pagamento com Margem Individual</InfoTitle>
							{consulta.medico.VL_margem_individual && <Info>R$ {(consulta.QT_credito * VL_credito * consulta.medico.VL_margem_individual).toFixed(2)} </Info>}
							{!consulta.medico.VL_margem_individual && <Info>Não se aplica</Info>}
						</InfoBlock>

					</PacientInfo>

				</Content>

				<MainButton
					bgcolor={
						consulta?.ST_transferencia === "SUCESSO" ? undefined : "#ff6961"
					}
					disabled={loadingAlterar}
					onClick={() => {
						if (consulta?.ST_transferencia === "SUCESSO") {
							handleStatusChange();
							toast.success("Pagamento feito!");
						} else if (consulta?.ST_transferencia_admin === "SUCESSO") {
							toast.error("O pagamento já foi realizado ao médico");
						} else {
							toast.error(
								"O pagamento ainda não foi realizado pelo paciente"
							);
						}
					}}
				>
					{
						loadingAlterar
							?
							<ReactLoading
								type="spin"
								color="#ffffff"
								height={"30px"}
								width={"30px"}
								className="m-auto"
							/>
							:
							"Marcar como Pago"
					}
				</MainButton>

			</PageContainer>
		</Page>
	);
}